export class AutoCompleteStyles {
    public list = {};
    public listItem = {};
    public searchbar = {};
}
